// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bNmE","left":"styles_left__2AE5H"};